// @flow

import React from 'react'
import { createComponent } from 'react-fela'
import PropTypes from 'prop-types'
import { __designLangBtn, __buttonWrapper } from './__style'
import SubLoader from '../SubLoader'

const ButtonWrapper = createComponent(__buttonWrapper, 'div')
const DesignLangBtn = createComponent(__designLangBtn, 'button', [
	'data-id',
	'data-auto',
])

const ButtonDesignLang = ({
	disabled,
	onClick,
	children,
	idSelector,
	autokey,
	loading,
	primary,
	secondary,
	smallBtn,
	mediumBtn,
	largeBtn,
	center,
	btnBg,
	fullWidth,
}) => {
	return (
		<ButtonWrapper center={center} btnBg={btnBg} fullWidth={fullWidth}>
			{!loading && (
				<DesignLangBtn
					data-id={idSelector}
					data-auto={autokey}
					disabled={!loading && disabled}
					onClick={loading || disabled ? null : onClick}
					passThrough={['onClick']}
					primary={primary}
					secondary={secondary}
					smallBtn={smallBtn}
					mediumBtn={mediumBtn}
					largeBtn={largeBtn}
					fullWidth={fullWidth}
				>
					{children}
				</DesignLangBtn>
			)}
			{loading && <SubLoader />}
		</ButtonWrapper>
	)
}

ButtonDesignLang.propTypes = {
	primary: PropTypes.bool,
	/** To toggle Loader */
	loading: PropTypes.bool,
	/** Default button height & width */
	heightMedium: PropTypes.bool,
}

ButtonDesignLang.defaultProps = {
	primary: true,
	loading: false,
	heightMedium: true,
}

export default ButtonDesignLang
